import { render, staticRenderFns } from "./callUs.vue?vue&type=template&id=b79fed12&scoped=true&"
import script from "./callUs.vue?vue&type=script&lang=js&"
export * from "./callUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79fed12",
  null
  
)

export default component.exports